import { t } from '@procumi/shared';
import { useState } from 'react';
import type { Toast } from '../hooks/useToast';
import { errMsg } from '../lib/api';

/**
 * „Datele tale, oricând” (2026-11-04): administratorul descarcă tot ce ține firma în Procumi,
 * într-o arhivă ZIP (liste pentru Excel, documentele originale, un JSON complet). E copia
 * promisă în Termeni (art. 8.3) și portabilitatea din GDPR; merge și în contul doar de citit.
 */
export function DataExportSection({ toast }: { toast: Toast }) {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const res = await fetch('/api/data-export', { credentials: 'same-origin' });
      if (!res.ok) {
        const body = (await res.json().catch(() => null)) as { error?: string } | null;
        throw new Error(body?.error || t('Arhiva nu s-a putut face. Încearcă din nou.'));
      }
      const name =
        /filename="([^"]+)"/.exec(res.headers.get('content-disposition') ?? '')?.[1] ?? 'procumi.zip';
      const url = URL.createObjectURL(await res.blob());
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 10_000);
      toast(t('Arhiva cu datele firmei s-a descărcat.'));
    } catch (e) {
      toast(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  // aceeași așezare ca rândurile de deasupra („Logo”, „Semnătura mailurilor”)
  return (
    <div className="set-row data-export">
      <div className="set-l">
        <h2 id="data-export-t">{t('Datele firmei, oricând la tine')}</h2>
        <p>{t('Copia tuturor datelor, pentru arhivă sau pentru alt program.')}</p>
      </div>
      <section className="sheet set-r" aria-labelledby="data-export-t">
        <p className="hint">
          {t(
            'O arhivă ZIP cu tot ce ține firma în Procumi: furnizorii, cererile, ofertele, comenzile și livrările ca liste pentru Excel, plus documentele originale primite de la furnizori.',
          )}
        </p>
        <button type="button" className="btn" disabled={busy} onClick={() => void download()}>
          {busy ? t('Se pregătește arhiva…') : t('Descarcă toate datele')}
        </button>
      </section>
    </div>
  );
}
